module.exports = __webpack_public_path__ + "static/img/30y.dc2d4d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30y.jpg
// module id = lGEo
// module chunks = 0